import React from 'react'
import Button, { TYPES } from '../Button/index'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'

/**
 * @param {Object} props - The props
 * @param {String} props.name - The name of the option
 * @param {Function} props.onClick - The option click handler
 * @param {boolean} props.isActive - The value indicating if the option is applied to the filter
 * @returns {JSX.Element} The Filter Option component
 */

function FiltersV2Option ({
  onClick,
  isActive,
  name,
}) {
  const buttonClassName = [
    'filters-v2__option-button',
    isActive ? 'filters-v2__option-button--active' : null,
    `test-filter-option-${name}`,
  ].filter((cls) => !!cls).join(' ')
  return (
    <li className="filters-v2__option">
      <Button
        type={TYPES.GHOST}
        onClick={onClick}
        className={buttonClassName}
        disabled={isActive}
      >
        {name}
        {isActive && (
          <IconV2
            className="filters-v2__option-icon"
            type={ICON_TYPES.CHECK}
          />
        )}
      </Button>
    </li>
  )
}

export default FiltersV2Option
